import getApiSettingsHelper from 'Helper/getApiSettings';

/**
 * interface fot fetching a send message instance
 */
export interface RefreshWebchatConfig {
    /**
     * userId
     */
    userId: string;
    /**
     * alias
     */
    alias: string;
    /**
     * secureKey
     */
    secureKey: string;
    /**
     * secureKey
     */
    nextPosition: string;
}

/**
 * sendMessage
 */
export const getApiSettings = (config: RefreshWebchatConfig) => {
    const params = new URLSearchParams();
    params.append('userId', config.userId);
    params.append('alias', config.alias);
    params.append('secureKey', config.secureKey);
    params.append('transcriptPosition', config.nextPosition);

    return getApiSettingsHelper(params);

};
